module.exports = __webpack_public_path__ + "static/doodleLarge-789ed3d5356def5a8cfb73a0bdeb1d59.png";